module.exports = __webpack_public_path__ + "media/images/emblems/Chavannes-de-Bogis-coat_of_arms-64d0d48c7d56ab088b19ab9c358e4aa9.svg";